import React, { FC } from 'react';
import { NavbarItem } from './NavbarItem';
import {
  DashboardIcon,
  PropertiesIcon,
  TenantsIcon,
  ReportsIcon,
  FinancialIcon,
  TicketsIcon,
  TransactionsIcon,
  PaymentsIcon,
  AccountIcon,
  SettingsIcon,
  SupportIcon,
  CalendarIcon,
  ChatsIcon,
  DevelopmentIcon, // Assuming you will create this icon
} from './Icons';

interface OwnerManagerMenuProps {
  isOwner: boolean;
  isCollapsed?: boolean;
}

export const OwnerManagerMenu: FC<OwnerManagerMenuProps> = ({ isOwner, isCollapsed = false }) => {
  return (
    <>
      <NavbarItem to={'/dashboard'} icon={<DashboardIcon />} exact={true} isCollapsed={isCollapsed}>
        Dashboard
      </NavbarItem>

      <NavbarItem to={'/dashboard/properties'} icon={<PropertiesIcon />} isCollapsed={isCollapsed}>
        Properties
      </NavbarItem>

      <NavbarItem to={'/dashboard/tenants'} icon={<TenantsIcon />} isCollapsed={isCollapsed}>
        Tenants
      </NavbarItem>

      <NavbarItem to={'/dashboard/reports'} icon={<ReportsIcon />} disabled={isOwner} isCollapsed={isCollapsed}>
        Reports
      </NavbarItem>

      {/*
      <NavbarItem
        icon={<FinancialIcon />}
        submenuItems={[
          { to: '/dashboard/financial/assessment', label: 'Assessment' },
          {
            to: '/dashboard/financial/statement',
            label: 'Statement of result',
          },
          { to: '/dashboard/financial/budget', label: 'Budget' },
          { to: '/dashboard/financial/income', label: 'Income' },
          { to: '/dashboard/financial/expenses', label: 'Expenses' },
        ]}
        isCollapsed={isCollapsed}
      >
        Financial statement
      </NavbarItem>
 */}
      <NavbarItem to={'/dashboard/tickets'} icon={<TicketsIcon />} isCollapsed={isCollapsed}>
        Complain management
      </NavbarItem>

      <NavbarItem to={'/dashboard/payments'} icon={<PaymentsIcon />} isCollapsed={isCollapsed}>
        Payment Management
      </NavbarItem>
      {/*
      <NavbarItem to={'/dashboard/transactions'} icon={<TransactionsIcon />} isCollapsed={isCollapsed}>
        Transactions
      </NavbarItem>
 */}
      <NavbarItem to={'/dashboard/chats'} icon={<ChatsIcon />} isCollapsed={isCollapsed}>
        Chats
      </NavbarItem>

      <NavbarItem to={'/dashboard/notifications'} icon={<ChatsIcon />} isCollapsed={isCollapsed}>
        Notifications
      </NavbarItem>

      <NavbarItem to={'/dashboard/calendar'} icon={<CalendarIcon />} isCollapsed={isCollapsed}>
        Calendar
      </NavbarItem>

      <NavbarItem to={'/dashboard/account'} icon={<AccountIcon />} isCollapsed={isCollapsed}>
        Account
      </NavbarItem>

      <NavbarItem to={'/dashboard/settings'} icon={<SettingsIcon />} disabled={isOwner} isCollapsed={isCollapsed}>
        Settings
      </NavbarItem>

      <NavbarItem to={'/dashboard/support'} icon={<SupportIcon />} disabled={isOwner} isCollapsed={isCollapsed}>
        Support
      </NavbarItem>

      {isOwner && (
        <NavbarItem to={'/dashboard/development'} icon={<DevelopmentIcon />} isCollapsed={isCollapsed}>
          Development
        </NavbarItem>
      )}
    </>
  );
};
